import { ORGANIZATION_NAME, SITE_URL, WEBSITE_NAME } from '../constants'
import { CasesIndexItem } from '../types'
import { buildBreadcrumbList } from './breadcrumb'

export interface CasesIndexSchemaInput {
  pageTitle: string
  description: string
  listName: string
  listDescription: string
  items: CasesIndexItem[]
}

export const buildCasesIndexSchema = (input: CasesIndexSchemaInput) => {
  const pageUrl = `${SITE_URL}/cases/`

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        '@id': pageUrl,
        url: pageUrl,
        name: input.pageTitle,
        description: input.description,
        isPartOf: {
          '@type': 'WebSite',
          name: WEBSITE_NAME,
          url: `${SITE_URL}/`,
        },
        publisher: {
          '@type': 'Organization',
          name: ORGANIZATION_NAME,
          url: `${SITE_URL}/`,
        },
        inLanguage: 'ja',
        mainEntity: { '@id': `${pageUrl}#itemlist` },
      },
      {
        '@type': 'ItemList',
        '@id': `${pageUrl}#itemlist`,
        name: input.listName,
        description: input.listDescription,
        numberOfItems: input.items.length,
        itemListElement: input.items.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Article',
            name: item.name,
            url: item.url,
          },
        })),
      },
      buildBreadcrumbList(pageUrl, [
        { name: 'ホーム', item: `${SITE_URL}/` },
        { name: '事例', item: pageUrl },
      ]),
    ],
  }
}
